export default {
	data(){
		return {
			tableGBoptions: { 
				options: {anular: 'Anular exámen'},
				modals: [
					{
					  "modal": "registrar",
					  "icon": "credit-card",
					  "title": "Registrar orden"
					},
				]
			},

			tableGBSearch: ['datos_pacientes/name'],
			
			tableGBItems: [
				{
					thead: { th: 'Nombre', sort: null, sortTable: 'datos_pacientes/name'},
					tbody: { td: ['datos_pacientes/name']}
				},
				{
					thead: { th: 'Direccion', },
					tbody: { td: ['datos_pacientes/direccion'],}
				},
				{
					thead: { th: 'Telefonos', },
					tbody: { td: ['datos_pacientes/telefonos'],}
				},
				{
					thead: { th: 'Exámen', },
					tbody: { td: ['info_examens/id'], link: '/api/pdf/examen' }
				},
				{
					thead: { th: 'Diagnostico', },
					tbody: { td: ['info_examens/id'], link: '/api/pdf/diagnosticos' }
				},
			]						
		}
	},	
}